export const ActivitySection = () => null
